export const EUMGridConfig = {
	grid: {
		gridId: 'EumFMVStatementReport',
		height: 500,
		checkbox: true,
		edit: false,
		delete: false,
		reorderable: false,
		columnMenu: true,
		sortable: true,
		pageSize: 10,
		groupable: false,
		scrollable: true
	},
	columns: {
		InvestmentGroup: {
			class: 'value',
			dataName: 'InvestmentGroup',
			type: 'string',
			title: 'Investment Group',
			width: 300,
			hidden: true,
			editable: false,
			template: "<span class='InvestmentGroup'>#= kendo.toString(InvestmentGroup, '') #</span>"
		},
		InvestmentID: {
			class: 'value',
			dataName: 'InvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 100,
			hidden: true,
			editable: false,

		},
		Investment: {
			class: 'value',
			dataName: 'Investment',
			type: 'string',
			title: 'Investment',
			template: '#=kendo.format("{0:n0}", Investment!=null?Investment:0)#',
			width: 550,
			hidden: false,
			editable: false,
			footerTemplate: "TOTAL UNIT VALUE",

		},
		InvestmentOrder: {
			class: 'value',
			dataName: 'InvestmentOrder',
			type: 'string',
			title: 'Investment Order',
			width: 100,
			hidden: true,
			editable: false,
		},
		Partner: {
			class: "value",
			dataName: 'Partner',
			type: 'string',
			title: 'Partner',
			width: 150,
			hidden: false,
			editable: false
		},
		Units: {
			class: "value",
			dataName: 'Units',
			type: 'number',
			title: 'Units',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n}", Units!=null?Units:0)#</span>',
			width: 150,
			hidden: false,
			editable: false
		},
		VestedPercent: {
			class: 'value',
			dataName: 'VestedPercent',
			type: 'number',
			title: 'Vesting Percentage',
			template: '<span class="number-cell-ui">#if(VestedPercent == null){# N/A #}else{# #=kendo.toString(VestedPercent, "p1")# #}#</span>',
			width: 150,
			hidden: false,
			editable: false
		},
		PreviousUnitDistribution: {
			class: "value",
			dataName: 'PreviousUnitDistribution',
			type: 'number',
			title: 'Previous Unit Distributions (Cumulative)',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("PreviousUnitDistribution") >= 0) {# - #} else {# #=kendo.format("{0:n0}", PreviousUnitDistribution!=null?PreviousUnitDistribution:0)# #}#</span>',
			width: 200,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		ProjectedUnrealizedValue: {
			class: "value",
			dataName: 'ProjectedUnrealizedValue',
			type: 'number',
			title: 'Projected Unrealized Value (Undiscounted)',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0) {# - #} else {# #=kendo.format("{0:n0}", ProjectedUnrealizedValue!=null?ProjectedUnrealizedValue:0)# #}#</span>',
			width: 200,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		PotentialPreTaxValue: {
			class: "value",
			dataName: 'PotentialPreTaxValue',
			type: 'number',
			title: 'Potential Pre-Tax Value',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", PotentialPreTaxValue!=null?PotentialPreTaxValue:0)#</span>',
			width: 150,
			hidden: true,
			editable: false
		},
		PriorPotentialPreTaxValue: {
			class: "value",
			dataName: 'PriorPotentialPreTaxValue',
			type: 'number',
			title: 'Prior Potential Pre-Tax Value',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", PriorPotentialPreTaxValue!=null?PriorPotentialPreTaxValue:0)#</span>',
			width: 150,
			hidden: true,
			editable: false
		},
		TotalPotentialPreTaxValue: {
			class: "value",
			dataName: 'TotalPotentialPreTaxValue',
			type: 'number',
			title: 'Total Potential Pre-Tax Value',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0) {# - #} else {# #=kendo.format("{0:n0}", TotalPotentialPreTaxValue!=null?TotalPotentialPreTaxValue:0)# #}#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		TotalPotentialPreTaxValuePercentChange: {
			class: "value",
			dataName: 'TotalPotentialPreTaxValuePercentChange',
			type: 'number',
			title: 'Total Potential Pre-Tax Value Percentage Change Since Prior Statement',
			template: '<span class="number-cell-ui">#if(TotalPotentialPreTaxValuePercentChange == null){# #if(HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0) {# - #} else {# N/A #}# #}else{# #if(HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0) {# - #} else {# #=kendo.toString(TotalPotentialPreTaxValuePercentChange, "p1")# #}# #}#</span>',
			width: 250,
			hidden: false,
			editable: false,
		},
		CurrentValue: {
			class: 'value',
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Values (Discounted)',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("CurrentValue") >= 0) {# - #} else {# #=kendo.format("{0:n0}", CurrentValue!=null?CurrentValue:0)# #}#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		CurrentPreTaxValue: {
			class: "value",
			dataName: 'CurrentPreTaxValue',
			type: 'number',
			title: 'Current Pre-Tax Value',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", CurrentPreTaxValue!=null?CurrentPreTaxValue:0)#</span>',
			width: 150,
			hidden: true,
			editable: false,
		},
		PriorCurrentPreTaxValue: {
			class: "value",
			dataName: 'PriorCurrentPreTaxValue',
			type: 'number',
			title: 'Prior Current Pre-Tax Value',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", PriorCurrentPreTaxValue!=null?PriorCurrentPreTaxValue:0)#</span>',
			width: 150,
			hidden: true,
			editable: false,
		},
		TotalCurrentPreTaxValue: {
			class: "value",
			dataName: 'TotalCurrentPreTaxValue',
			type: 'number',
			title: 'Total Current Pre-Tax Value',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValues") >= 0) {# - #} else {# #=kendo.format("{0:n0}", TotalCurrentPreTaxValue!=null?TotalCurrentPreTaxValue:0)# #}#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		TotalCurrentPreTaxValuePercentChange: {
			class: "value",
			dataName: 'TotalCurrentPreTaxValuePercentChange',
			type: 'number',
			title: 'Total Current Pre-Tax Value Percentage Change Since Prior Statement',
			template: '<span class="number-cell-ui">#if(TotalCurrentPreTaxValuePercentChange == null){# #if(HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0) {# - #} else {# N/A #}# #}else{# #if(HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0) {# - #} else {# #=kendo.toString(TotalCurrentPreTaxValuePercentChange, "p1")#  #}# #}#</span>',
			width: 250,
			hidden: false,
			editable: false,
		},
	}
}

export const EPPGridConfig = {
	grid: {
		gridId: 'EppFMVStatementReport',
		checkbox: true,
		edit: false,
		delete: false,
		reorderable: false,
		columnMenu: true,
		sortable: true,
		pageSize: 10,
		groupable: false,
		scrollable: true
	},
	columns: {
		InvestmentGroup: {
			class: 'value',
			dataName: 'InvestmentGroup',
			type: 'string',
			title: 'Investment Group',
			width: 100,
			hidden: true,
			editable: false
		},
		InvestmentID: {
			class: 'value',
			dataName: 'InvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 100,
			hidden: true,
			editable: false,

		},
		Investment: {
			class: 'value',
			dataName: 'Investment',
			type: 'string',
			title: 'Investment',
			template: '#=kendo.format("{0:n0}", Investment!=null?Investment:0)#',
			width: 250,
			hidden: false,
			editable: false,
			footerTemplate: "TOTAL DIRECT INVESTMANT VALUE",

		},
		InvestmentOrder: {
			class: 'value',
			dataName: 'InvestmentOrder',
			type: 'string',
			title: 'Investment Order',
			width: 100,
			hidden: true,
			editable: false,
		},
		CommitmentFunded: {
			class: "value",
			dataName: 'CommitmentFunded',
			type: 'number',
			title: 'Commitment Funded',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", CommitmentFunded!=null?CommitmentFunded:0)#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		CommitmentRemaining: {
			class: 'value',
			dataName: 'CommitmentRemaining',
			type: 'number',
			title: 'Commitment Remaining',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", CommitmentRemaining!=null?CommitmentRemaining:0)#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		CommitmentTotal: {
			class: 'value',
			dataName: 'CommitmentTotal',
			type: 'number',
			title: 'Commitment Total',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", CommitmentTotal!=null?CommitmentTotal:0)#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		PreviousUnitDistribution: {
			class: "value",
			dataName: 'PreviousUnitDistribution',
			type: 'number',
			title: 'Previous Cash Distributions',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("PreviousUnitDistribution") >= 0) {# - #} else {# #=kendo.format("{0:n0}", PreviousUnitDistribution!=null?PreviousUnitDistribution:0)# #}#</span>',
			width: 200,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		ProjectedUnrealizedValue: {
			class: "value",
			dataName: 'ProjectedUnrealizedValue',
			type: 'number',
			title: 'Projected Unrealized Value (Undiscounted)',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0) {# - #} else {# #=kendo.format("{0:n0}", ProjectedUnrealizedValue!=null?ProjectedUnrealizedValue:0)# #}#</span>',
			width: 200,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		PotentialPreTaxValue: {
			class: "value",
			dataName: 'PotentialPreTaxValue',
			type: 'number',
			title: 'Potential Pre-Tax Value',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", PotentialPreTaxValue!=null?PotentialPreTaxValue:0)#</span>',
			width: 100,
			hidden: true,
			editable: false,
		},
		PriorPotentialPreTaxValue: {
			class: "value",
			dataName: 'PriorPotentialPreTaxValue',
			type: 'number',
			title: 'Prior Potential Pre-Tax Value',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", PriorPotentialPreTaxValue!=null?PriorPotentialPreTaxValue:0)#</span>',
			width: 100,
			hidden: true,
			editable: false
		},
		TotalPotentialPreTaxValue: {
			class: "value",
			dataName: 'TotalPotentialPreTaxValue',
			type: 'number',
			title: 'Total Potential Pre-Tax Value',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0) {# - #} else {# #=kendo.format("{0:n0}", TotalPotentialPreTaxValue!=null?TotalPotentialPreTaxValue:0)# #}#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		TotalPotentialPreTaxValuePercentChange: {
			class: "value",
			dataName: 'TotalPotentialPreTaxValuePercentChange',
			type: 'number',
			title: 'Total Potential Pre-Tax Value Percentage Change Since Prior Statement',
			template: '<span class="number-cell-ui">#if(TotalPotentialPreTaxValuePercentChange == null){# #if(HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0) {# - #} else {# N/A #}# #}else{# #if(HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0) {# - #} else {# #=kendo.toString(TotalPotentialPreTaxValuePercentChange, "p1")# #}# #}#</span>',
			width: 250,
			hidden: false,
			editable: false,
		},
		CurrentValue: {
			class: 'value',
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Values (Discounted)',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("CurrentValue") >= 0) {# - #} else {# #=kendo.format("{0:n0}", CurrentValue!=null?CurrentValue:0)# #}#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		CurrentPreTaxValue: {
			class: "value",
			dataName: 'CurrentPreTaxValue',
			type: 'number',
			title: 'Current Pre-Tax Value',
			width: 100,
			hidden: true,
			editable: false,
		},
		PriorCurrentPreTaxValue: {
			class: "value",
			dataName: 'PriorCurrentPreTaxValue',
			type: 'number',
			title: 'Prior Current Pre-Tax Value',
			width: 100,
			hidden: true,
			editable: false,
		},
		TotalCurrentPreTaxValue: {
			class: "value",
			dataName: 'TotalCurrentPreTaxValue',
			type: 'number',
			title: 'Total Current Pre-Tax Value',
			template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValues") >= 0) {# - #} else {# #=kendo.format("{0:n0}", TotalCurrentPreTaxValue!=null?TotalCurrentPreTaxValue:0)# #}#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		TotalCurrentPreTaxValuePercentChange: {
			class: "value",
			dataName: 'TotalCurrentPreTaxValuePercentChange',
			type: 'number',
			title: 'Total Current Pre-Tax Value Percentage Change Since Prior Statement',
			template: '<span class="number-cell-ui">#if(TotalCurrentPreTaxValuePercentChange == null){# #if(HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0) {# - #} else {# N/A #}# #}else{# #if(HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0) {# - #} else {# #=kendo.toString(TotalCurrentPreTaxValuePercentChange, "p1")#  #}# #}#</span>',
			width: 250,
			hidden: false,
			editable: false,
		},
	}
}

export const FMVStatementToolBarConfig = {
	list: 'ToolBarItems',
	items: [{
		id: "btnExportPdf",
		name: "export",
		type: "button",
		icon: "pdf",
		showIcon: "toolbar",
		attributes: {
			"class": "fa fa-file-pdf-o float-right-btn relPosition1",
			"title": "Export to Pdf"
		}
	},]
}